export default __webpack_public_path__ + "static/media/waffle.af0b3984.svg";